module.exports = __webpack_public_path__ + "img/msg-icon.68798456.svg";